import { useDictStore } from "@/stores/dictStore";

import { PricingStrategy, PriceResult } from "../base/pricing.strategy";
import { Partition } from "../../entities/partition";

export class GlassPricingStrategy extends PricingStrategy {
    private dictStore = useDictStore();

    public getPrices(...args: unknown[]): PriceResult {
        const [installedSystemCode, stateCode, partition] = args as [
            string,
            string,
            Partition,
        ];

        const glass = partition.getActiveGlass();
        const glassThinkness = partition.getActiveGlassThinkness();

        if (!glass || !glassThinkness) {
            return this.getDefaultPrices();
        }

        const pricesFromDict = this.dictStore.findGlassPrice(
            glass.structureType!,
            glassThinkness.structureType!,
            stateCode,
        );

        if (!this.validatePricesFromDict(pricesFromDict)) {
            return this.getDefaultPrices();
        }

        return {
            price: pricesFromDict.price!,
            priceB2C: pricesFromDict.priceGlass!,
            priceB2B: pricesFromDict.priceEdging!,
        };
    }
}
